class InstaSwiper {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const mySwiper = new Swiper('.swiper', {
      loop: true,
      slidesPerView: 3.2,
      spaceBetween: 16,
      speed: 5000,
      preventInteractionOnTransition: false,
      disableOnInteraction: false,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      mousewheel: {
        forceToAxis: true,
        sensitivity: 3
      },
      breakpoints: {
        768: {
          slidesPerView: 6.8,
          spaceBetween: 20,
        },
        1800: {
          slidesPerView: 9.4,
          spaceBetween: 20,
        },
      }
    });
  }
}